import { isFieldZone } from './_shared';

/**
 * **対象に取る**（Issue #589）。`field` ＝ 場のカードが対象（`targets` は場のものだけ）/
 * `elsewhere` ＝ 墓地・除外・手札など盤に無いカードだけが対象（`targets` はその全部）。
 * 事実: `chain`（どのリンクの対象か）/ `player`（発動したプレイヤー）/ `targets`（`{ uid, zone }`）。uid の無い対象しか無ければ null
 */
export const VARIANTS = Object.freeze([
  { name: 'field', label: '場のカードが対象' },
  { name: 'elsewhere', label: '盤に無いカードが対象' },
]);

export default Object.freeze({
  event: 'become_target',
  variants: VARIANTS,
  classify({ payload }) {
    const links = payload?.chainLinks ?? [];
    const link = links[links.length - 1] ?? null;
    const all = (payload?.cards ?? []).filter((c) => c?.uid).map((c) => ({ uid: c.uid, zone: c.zone ?? null }));
    if (!all.length) return null;
    const onField = all.filter((c) => isFieldZone(c.zone));
    return {
      ...payload,
      variant: onField.length ? 'field' : 'elsewhere',
      chain: link?.chain ?? 0,
      player: link?.player ?? payload?.player ?? 0,
      targets: onField.length ? onField : all,
    };
  },
});
